import React, { FC, useEffect } from 'react';
import { getScrollbarWidth } from '~/src/helpers/get-scrollbar-width';
import { SvgClose } from '~/src/components/svg-components/close';
import type { PopupProps } from '~/src/components/common-components/popup/popup.types';
import * as Styled from './popup.styles';

/**
 * Used in Module Federation
 */
const Popup: FC<PopupProps> = ({ popupStack, closePopup, showCloseX = false }) => {
    const topStackContent = popupStack[popupStack.length - 1];

    useEffect(() => {
        document.body.style.marginRight = popupStack.length ? `${getScrollbarWidth()}px` : '0';
        document.body.style.overflow = popupStack.length ? 'hidden' : 'auto';
    }, [popupStack]);

    return (
        <>
            <Styled.PopupBackground data-testid={'background'} isOpen={Boolean(popupStack.length)} />
            {!!popupStack.length && (
                <Styled.PopupBaseLayer onMouseDown={closePopup} data-testid={'base-layer'}>
                    <Styled.PopupWrap>
                        <Styled.PopupWindow onMouseDown={(event) => event.stopPropagation()}>
                            {showCloseX && (
                                <Styled.CloseWrapper onClick={closePopup} data-testid={'close-wrapper'}>
                                    <SvgClose width={32} height={32} />
                                </Styled.CloseWrapper>
                            )}
                            {topStackContent.content}
                        </Styled.PopupWindow>
                    </Styled.PopupWrap>
                </Styled.PopupBaseLayer>
            )}
        </>
    );
};

export default Popup;
